//region import
import React, {useCallback, useState} from "react"
import './go-isu.scss'
import {Button} from "devextreme-react/button";
import LoadPanel from "devextreme-react/load-panel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
//import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import {faExternalLink} from "@fortawesome/free-solid-svg-icons/faExternalLink";
import {getDogToken} from "../../api/point";
import {notifyIsueAuthFail} from "../../utils/isue-notify";
import {useAuth} from "../../contexts/auth";
//endregion

const GoIsuPage = () => {

    const { selectedDog } = useAuth()
    const [loading, setLoading] = useState(false)
    const [disabledIsue, setDisabledIsue] = useState(false)
    const isuOrIsue = process.env.REACT_APP_NAME_ENV !== 'renergy' ? "Э" : ""
    const onIsue = useCallback(async () => {
        setLoading(true)
        if (selectedDog) {
            setDisabledIsue(false)
            let resToken
            resToken = await getDogToken(selectedDog?.kodDog)
            if (resToken.isOk) {
                let json = resToken.data
                if (json.hasOwnProperty('token')){
                    window.open(json.url + json.token, '_blank');
                } else {
                    notifyIsueAuthFail({message: 'Объект не содержит token'}, 'dog')
                }
            } else {
                notifyIsueAuthFail(resToken, 'dog')
            }
        }
        setLoading(false)
    },[selectedDog])

    return (
        <div className={'content-block dx-card responsive-paddings popupWithUploader'}>
            <LoadPanel visible={loading} />
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faExternalLink} />
            {/*TODO на бэк прописать в меню ИСУ(rgmek) или ИСУЭ(остальные)*/}
            <h3><strong>Данные ИСУ{isuOrIsue}{/*<ZagolovokFromMenu/>*/}</strong></h3>
            <Button disabled={disabledIsue} type="default" text={`Перейти в ИСУ${isuOrIsue}`}
                    className={'mt-4'}
                    hint={`Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУ${isuOrIsue})`}
                    icon="refresh" onClick={() => onIsue()}/>
        </div>


    )
}

export default GoIsuPage
